import _styled from "@emotion/styled/base";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../primitives/List/Item/components/Container.js';
export const Item = /*#__PURE__*/_styled(({
  size = 'medium',
  icon,
  label,
  children,
  ...restProps
}) => {
  return _jsxs(Container, {
    ...restProps,
    size: size,
    withIcon: Boolean(icon),
    role: "listitem",
    children: [icon, _jsxs("div", {
      children: [label, children]
    })]
  });
}, {
  label: 'ListItem',
  target: "eeavfzu0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0ciLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvTGlzdC9JdGVtL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmV4cG9ydCBjb25zdCBJdGVtID0gc3R5bGVkKCh7IHNpemUgPSAnbWVkaXVtJywgaWNvbiwgbGFiZWwsIGNoaWxkcmVuLCAuLi5yZXN0UHJvcHMgfSkgPT4ge1xuICAgIHJldHVybiAoX2pzeHMoQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgc2l6ZTogc2l6ZSwgd2l0aEljb246IEJvb2xlYW4oaWNvbiksIHJvbGU6IFwibGlzdGl0ZW1cIiwgY2hpbGRyZW46IFtpY29uLCBfanN4cyhcImRpdlwiLCB7IGNoaWxkcmVuOiBbbGFiZWwsIGNoaWxkcmVuXSB9KV0gfSkpO1xufSwge1xuICAgIGxhYmVsOiAnTGlzdEl0ZW0nLFxufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1JdGVtLmpzLm1hcCJdfQ== */");